import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useUsersListQuery } from 'api';
import { GoBackButtonWithTitle, PageHeaderBoldTitle, PageWrapper, Spinner } from 'components';
import { UserStatus } from 'types';

import { EditEquipmentForm } from '../../components';

export function EditEquipmentPage(): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { isLoading: isLoadingUsersList, usersList } = useUsersListQuery({
    status: [UserStatus.Active, UserStatus.Registered],
  });

  if (isLoadingUsersList) {
    return <Spinner />;
  }

  return (
    <PageWrapper>
      <GoBackButtonWithTitle
        title={t('common.back')}
        onClick={() => navigate(-1)}
        containerSx={{
          marginTop: 0,
          maxWidth: '100%',
        }}
      />
      <PageHeaderBoldTitle title={t('equipments.create.title')} />
      <EditEquipmentForm usersList={usersList} />
    </PageWrapper>
  );
}
